<template lang="pug">
  .component-backoffice-wallet-record(v-if="item")
    .component-card(v-if="$is('listing')" )
      .row
        .column
          label ID
          .field-value WR{{item.id}}
        .column
          label Type & Id
          .field-value {{item.walletable_type | walletableType}}
            br
            span {{item.walletable_id}}
        .column
          label Tax {{-item.tax*100}}%
          .field-value {{$priceWithcurrency(parseFloat(item.amount * item.tax).toFixed(2))}}
        .column
          label Amount
          .field-value {{$priceWithcurrency(-item.amount)}}
        .column
          label Invoice
          .field-value.h3.mb-0 {{commercialDocumentType}}{{item.invoice.internal_id}}({{item.invoice.id}})
    .component-card(v-if="$is('multi-wallet')")
      .row.pb-0
        .column.expand
          h3.mb-0 {{walletableType}} {{item.walletable_id}}
          .fields
            small WR{{item.id}}
        .column.large-2
          .field-content
            .label Created
            .field-value {{$dateFormat(item.created, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
            .invoice-after(v-if="item.invoice_after !== null")
              .label Invoice on
              .field-value {{$dateFormat(item.invoice_after, $toMomentFormat(configuration.locale.locale_date_format.value))}}

      .row.pt-0.pb-0
        .column
          .label Description
          div(v-for="reason in item.reason.split('|')")
            hr(v-if="reason.startsWith('---')", style="border-style: dotted; margin:0.5em")
            strong(v-else-if="reason.startsWith('- ')") {{cleanString(reason,"- ")}}
            span(v-else-if="reason.startsWith('>>')", style="display: block; text-indent: 1em;") {{cleanString(reason,">>")}}
            span(v-else) {{reason}}
      .row.text-center.bottom
        template(v-if="walletableType !== 'Invoice'")
          .column.shrink
            .label Vat {{-item.tax*100}}%
            h3.mb-0 {{$priceWithcurrency(vat.toFixed(2))}}
          .column.shrink
            .label Amount
            h3.mb-0 {{$priceWithcurrency(item.amount.toFixed(2))}}
          .column.shrink
            .label Total
            h3.mb-0 {{$priceWithcurrency((item.amount + vat).toFixed(2))}}
          template(v-if="item.hasOwnProperty('invoice')" )
            .column.shrink(v-if="item.invoice.internal_id")
              .label Invoice
              router-link(:to="{name:'invoice', params:{id:item.invoice.id}}")
                h3.mb-0 {{commercialDocumentType}}{{item.invoice.internal_id}}
            .column.shrink(v-else-if="!item.invoice.internal_id && item.billable")
              .label Invoice
              .field-value Not invoiced yet
        template(v-else)

          .column.shrink
            .label Subtotal
            h3.mb-0 {{(item.amount.toFixed(2))}}
          .column.shrink(v-if="item.invoice.internal_id")
            .label Invoice
            router-link(:to="{name:'invoice', params:{id:item.invoice.id}}")
              h3.mb-0 {{commercialDocumentType}}{{item.invoice.internal_id}}
          .column.shrink(v-else-if="!item.invoice.internal_id && item.billable")
            .label Invoice
            .field-value Not invoiced yet
</template>

<script type="text/babel">
    import Card7 from 'components/structure/Tab7.vue'
    import WalletRecordFields from '../structure/ui/entity-fields/WalletRecordFields.vue'
    import Accordion from '../structure/foundation/Accordion'
    import CardN from '../structure/CardN'
    import {mapState} from 'vuex'

    export default {
        name: 'BackofficeWalletRecord',
        props: {
            item: Object,
            type: {
                type: String,
                default: ''
            }
        },
        created() {
        },
        components: {
            CardN,
            Accordion,
            WalletRecordFields,
            Card7,
        },
        methods: {
          cleanString(string, char) {
            const r = new RegExp(`${char}`, 'gi');
            return string.replace(r, "")
          }
        },
        computed: {
            lines: function () {
                return this.item.reason.split('|')
            },
            walletableType() {
                return this.item.walletable_type.replace(/App\\Models\\/, '')
            },
            ...mapState({
                configuration: state => state.configuration,
            }),
            vat() {
                return ((this.item.amount * -1) * this.item.tax)
            },
            commercialDocumentType() {
                switch (this.item.invoice.type) {
                    case 'INVOICE':
                        return 'INV'
                    case 'CREDIT NOTE':
                        return 'CRN'
                    case 'PROFORMA':
                        return 'PRO'
                }
            }
        },
      filters: {
        walletableType(value) {
          return value.replace(/App\\Models\\/, '')
        }
      },
    }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-wallet-record
    .bottom
      justify-content: center
</style>



// WEBPACK FOOTER //
// WalletRecord.vue?2be6d1dd